import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Rekprof logo",
  class: "logo_min",
  src: "../../../../assets/logo.png"
}, null, -1)
const _hoisted_2 = { class: "inner_step_box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, "4.2 Ручной ввод адреса", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, "Введите адрес (улица Ильича, переулок Брежнева)", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, " Введите район                                                              Введите номер дома ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, " Введите корпус                                                            Введите литеру или строение ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, " Введите номер места                                                  Введите пересечение с домом или павильон ", -1)
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_menu_list = _resolveComponent("v-menu-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_v_menu_list),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("input", {
        ref: "map_file",
        type: "file",
        hidden: "",
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submitFile('map_file')))
      }, null, 544),
      _createElementVNode("button", {
        type: "button",
        class: "blue_btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.map_file.click())),
        style: {"float":"left","margin-left":"10px"}
      }, " Загрузить картинку с картой "),
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        class: "main_input",
        placeholder: "Введите адрес (улицу)",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.storeDM.save_obj.map_address) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.map_address]
      ]),
      _hoisted_5,
      _hoisted_6,
      _withDirectives(_createElementVNode("input", {
        class: "first_input",
        placeholder: "Введите район",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.storeDM.save_obj.map_district) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.map_district]
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "two_input",
        placeholder: "Введите номер дома",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.storeDM.save_obj.map_house) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.map_house]
      ]),
      _hoisted_7,
      _hoisted_8,
      _withDirectives(_createElementVNode("input", {
        class: "first_input",
        placeholder: "Введите корпус",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.storeDM.save_obj.map_korpus) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.map_korpus]
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "two_input",
        placeholder: "Введите литеру или строение",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.storeDM.save_obj.map_build_litera) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.map_build_litera]
      ]),
      _hoisted_9,
      _hoisted_10,
      _withDirectives(_createElementVNode("input", {
        class: "first_input",
        placeholder: "Введите номер места",
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.storeDM.save_obj.map_place) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.map_place]
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "two_input",
        placeholder: "Введите пересечение с домом или павильон если имеется",
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.storeDM.save_obj.map_cross) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.map_cross]
      ])
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "white_s_btn",
      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.go_back()))
    }, "Назад"),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["next_btn", { active_btn: _ctx.step_next }]),
      disabled: !_ctx.step_next,
      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.go_next()))
    }, " Далее ", 10, _hoisted_11)
  ], 64))
}